/** Spinners are only allowed inside buttons (`isLoading`); sections use skeletons and the shell uses BrandSplash. */
export const Spinner = {
  baseStyle: { color: "leaf.600" },
  defaultProps: { thickness: "3px", speed: "0.7s" },
};
